<template>
    <div class="content">
        <div class="row">
            <div class="col-md-12">
                <a-card>
                    <form @submit.prevent="addData($event)">
                        <div class="row">
                            <a-divider>تنظیمات بنر ها</a-divider>
                            <draggable  :animation="300" 
                                      draggable="false">
                                        <div v-for="row in data" class="my-list">
                                            <th scope="row">#{{ row . id }}</th>
                                           
                                            <td class="w-25">
                                                       <b-badge style="font-size: 15px;" variant="light" class="text-dark">{{ row . title }}</b-badge>
                                                       
                                                       <b-badge  variant="light" class="bg-info"
                        >{{ row.type }}</b-badge
                      >
                                            </td>

                                                  <td class="w-25">
                                                       <b-badge style="font-size: 15px;" variant="light" class="text-dark">{{ row . hint }}</b-badge>
                                            </td>

                                        
                                            <td class="w-25">
                                            <label>قیمت</label>
                                               <input :name="row.id" type="number" class="form-control" :value="row.price" >
                                            </td>
                                          </div>
                                    </draggable>
                            


                        </div>
                        <div class="card-footer  ">
                            <div class="row ">
                                <div class="col-md-10"></div>
                                <div class="col-md-1 ">
                                    <button type="submit" class="btn btn-fill btn-outline-success w-100" :disabled="!$root.hasPermission('/banners/setting/')">
                                        ذخیره
                                    </button>
                                </div>
                                
                               
                            </div>

                        </div>
                    </form>
                </a-card>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        data() {
            return {
                info: {
                },
                parents:[],
                data:[]
            };
        },
        mounted() {
            this.getAll();
        },
        methods: {
            async getAll() {
                let _this = this;
                let url = '/sliders/setting';
                await axios
                    .get(url)
                    .then(function(response) {
                        _this.data=response.data
                    })
                    .catch(function(err) {
                        _this.$root.handleAxiosError(err);
                    });
            },
            addData(event) {
                let _this = this;
                let data = new FormData(event.target);
                _this.$root.loading = true;

                axios
                    .post("/sliders/setting/edit",data)
                    .then(function(response) {
                        _this.$root.loading = false;
                        _this.$toast.success(" تنظیمات با موفقیت ویرایش شد");
            
                    })
                    .catch(function(err) {
                        _this.$root.loading = false;
                        _this.$root.handleAxiosError(err);
                    });
            },
        },
    };
</script>
